import StyledDialog from "../StyledDialog/StyledDialog";
import Confirmation from "./Confirmation";

interface IProps {
  isOpen: boolean;
  title?: string;
  description?: string;
  cancelText?: string;
  confirmText?: string;
  onCancel?: () => void;
  onConfirm?: () => Promise<void>;
  onClose: () => void;
}

const ConfirmationModal = ({ isOpen, onClose, ...restProps }: IProps) => {
  return (
    <StyledDialog maxWidth="md" open={isOpen} onClose={onClose}>
      <Confirmation {...restProps} />
    </StyledDialog>
  );
};

export default ConfirmationModal;
